/**
 * Where the API and the user pool live.
 *
 * Supplied at build time by Vite so the bundle carries no runtime lookup. The CDK stack
 * prints all three when it deploys.
 */
export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL ?? '';

/**
 * The public half of the VAPID key pair, base64url.
 *
 * Not a secret — it is handed to the browser as `applicationServerKey` — so it lives in build
 * configuration next to the API URL rather than behind a route. `make vapid-key` prints it.
 */
export const VAPID_PUBLIC_KEY: string =
  (import.meta.env.VITE_VAPID_PUBLIC_KEY as string | undefined) ?? '';

export const COGNITO = {
  region: (import.meta.env.VITE_AWS_REGION as string | undefined) ?? 'us-east-1',
  clientId: (import.meta.env.VITE_COGNITO_CLIENT_ID as string | undefined) ?? '',
};
